(() => {
    const customerEanModal = document.querySelector("#customer-ean-code-modal");

    if (!customerEanModal) {
        return;
    }

    $(customerEanModal).on("show.bs.modal", async (e) => {
        // FIXME: Classic case of DRY violation (Don't Repeat Yourself)
        const eanHolderEl = document.querySelector(".js-customer-ean-code-holder");
        if (!eanHolderEl) {
            console.error("CustomerEan: Ean holder not found");
            return;
        }

        const eanEl = eanHolderEl.querySelector(".js-customer-ean-code");
        if (!eanEl) {
            console.error("CustomerEan: Ean element not found");
            return;
        }

        const eanCode = eanEl.getAttribute("data-code");
        if (!eanCode) {
            console.error("CustomerEan: Code not found");
            return;
        }

        import("jsbarcode/dist/barcodes/JsBarcode.ean-upc.min.js").then(() => {
            if (eanHolderEl.classList.contains("is-initialized")) {
                return;
            }

            const eanErrorEl = document.querySelector(".js-customer-ean-code-error");

            eanEl.classList.remove("hidden");
            eanHolderEl.classList.remove("has-error");
            eanErrorEl.classList.add("hidden");

            try {
                JsBarcode(eanEl, eanCode, {
                    width: 3,
                    margin: 16,
                    height: 100,
                    lineColor: "#000",
                    background: "transparent",
                    flat: true,
                });

                eanHolderEl.classList.add("is-initialized");
            } catch (e) {
                console.error("CustomerEan: Error while initializing barcode", e);

                eanEl.classList.add("hidden");
                eanHolderEl.classList.add("has-error");
                eanErrorEl.classList.remove("hidden");
                eanErrorEl.innerHTML = e?.message || e;
            }
        });
    });
})();
